/**
 * Detects user's reduced motion preference.
 * Returns true when user has requested minimal motion.
 * Use this to conditionally disable or simplify animations.
 */
export function useReducedMotion(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}